// src/hooks/usePageSearch.js
import Fuse from "fuse.js";
import allPages from "../../data/pagesIndex"; // Your new pages index

const options = {
  keys: [
    { name: "title", weight: 0.6 },
    { name: "meta.description", weight: 0.5 },
    { name: "meta.keywords", weight: 0.5 }
  ],
  threshold: 0.2,
  includeMatches: true
};

const fuse = new Fuse(allPages, options);

const usePageSearch = () => {
  const searchPages = (query) => {
    if (!query.trim()) return [];
    const results = fuse.search(query);
    return results.map(result => ({
      item: result.item || {}, // Ensure item exists
      matches: result.matches || []
    }));
  };

  return { searchPages };
};

export default usePageSearch;